import color from '@shared/styles/color';
import spacing from '@shared/styles/spacing';
import { css } from '@emotion/react';

const base = css`
    color: ${color.mako};
    background-color: ${color.white};
    padding: 0 ${spacing.sideSpace};
    height: 64px;
    border-bottom: 1px solid ${color.alto};
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 999;
    width: 100%;

    @media (max-width: 768px) {
        display: none;
    }
`;

const logoWrapper = css`
    padding: 15px 0;
    flex-shrink: 0;
    cursor: pointer;

    img {
        width: 75%;
        height: auto;
    }

    @media (max-width: 1024px) {
        padding: 12px 0;
    }

    @media (max-width: 768px) {
        padding: 10px 0;
    }
`;

const navigationWrapper = css`
    font-size: 13px;
    padding: 24px 0;
    font-weight: 500;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    /* Style untuk .dropdown - sama persis dengan public-frontend */
    .dropdown {
        margin: 0 8px;
    }

    .dropdown:last-child {
        margin-right: 0;
        margin-left: 5px;
    }

    .ant-dropdown-trigger {
        margin: 0;
        white-space: nowrap;
    }

    .single-menu a {
        color: ${color.mako};
    }

    @media (min-width: 1300px) {
        .dropdown {
            margin: 0 12px;
        }

        .dropdown:last-child {
            margin-right: 0;
            margin-left: 5px;
        }
    }

    @media (max-width: 1200px) {
        font-size: 12px;

        .ant-dropdown-trigger {
            font-size: 12px;
        }
    }

    @media (max-width: 1024px) {
        padding: 16px 0;
        font-size: 11px;

        .ant-dropdown-trigger {
            font-size: 11px;
            padding: 4px 8px;
        }
    }

    @media (max-width: 900px) {
        font-size: 10px;

        .ant-dropdown-trigger {
            font-size: 10px;
            padding: 4px 6px;
        }
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

const navPicIcon = css`
    img {
        width: 18px;
        height: 18px;
    }

    @media (max-width: 1024px) {
        img {
            width: 16px;
            height: 16px;
        }
    }
`;

const navWithButton = css`
    border-radius: 5px;
    margin-top: -7px;
    margin-left: 0;
    margin-right: 0;
    white-space: nowrap;

    @media (max-width: 1200px) {
        font-size: 12px;
        padding: 4px 12px;
    }

    @media (max-width: 1024px) {
        font-size: 11px;
        padding: 4px 10px;
    }

    @media (max-width: 900px) {
        font-size: 10px;
        padding: 4px 8px;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

const advertiseButton = css`
    ${navWithButton}
    border: 1px solid #4589dc;
    color: #4589dc;
`;

const navProfileButton = css`
    margin-top: -7px;
    margin-left: 0;
    margin-right: 0;

    @media (max-width: 768px) {
        display: none;
    }
`;

const languageToggle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    cursor: pointer;
`;

const languageAvatar = css`
    background-color: rgba(0, 0, 0, 0.65) !important;
    text-transform: lowercase;
    font-weight: 500;
`;

const languageText = css`
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-weight: 400;
`;

const styles = {
    base,
    logoWrapper,
    navigationWrapper,
    navPicIcon,
    navWithButton,
    advertiseButton,
    navProfileButton,
    languageToggle,
    languageAvatar,
    languageText,
};

export default styles;
